import { GetPatientDetailsSchema } from '@montugroup/pms-api-contracts';
import { DateTime } from 'luxon';
import { z } from 'zod';

const validNameRegex = /^(?!.*\s['-])(?!.*['-]\s)[A-Za-z0-9' -]+\s?$/;

export const schema = GetPatientDetailsSchema.shape.basicInfo
  .unwrap()
  .shape.attributes.pick({
    firstName: true,
    lastName: true,
    gender: true,
    dob: true,
    atsiStatus: true,
    consent: true,
    doctorId: true
  })
  .extend({
    dvaNumber: z.string().nullable().optional()
  })
  .partial()
  .refine(
    (data) =>
      !data.dob ||
      (DateTime.fromISO(data.dob).isValid && DateTime.fromISO(data.dob) <= DateTime.now().minus({ years: 18 })),
    {
      path: ['dob'],
      message: 'Age must be at least 18 years old.'
    }
  )
  .refine((data) => !data.firstName || validNameRegex.test(data.firstName), {
    path: ['firstName'],
    message:
      "First name can only contain letters, numbers, apostrophes ('), hyphens (-), and spaces. No spaces allowed next to apostrophes or hyphens."
  })
  .refine((data) => !data.lastName || validNameRegex.test(data.lastName), {
    path: ['lastName'],
    message:
      "Last name can only contain letters, numbers, apostrophes ('), hyphens (-), and spaces. No spaces allowed next to apostrophes or hyphens."
  });
